import type { MentionSuggestion } from 'common/api/endpoints/mentions';
import type { StrippedUser } from 'common/api/endpoints/users';
import type { MimeTypeValues } from 'common/constants/files';

export type IdeaCommentFile = {
  mimeType: MimeTypeValues | null;
  name: string;
  url: string;
};

export type IdeaComment = {
  _id: string;
  authorID: string;
  author: StrippedUser;
  companyID: string;
  created: string;
  deleted: boolean;
  deletedAt: string | null;
  files: IdeaCommentFile[];
  fileURLs: string[];
  ideaDeleted: boolean;
  ideaID: string;
  imageURLs: string[];
  mentionedUsers: MentionSuggestion[];
  parentID: string | null;
  value: string;
};

export type CreateIdeaCommentRequest<ID = string> = {
  fileURLs?: string;
  ideaID: ID;
  imageURLs?: string;
  parentID?: ID | null;
  value: string;
};

export type UpdateIdeaCommentRequest<ID = string> = {
  commentID: ID;
  fileURLs?: string;
  imageURLs?: string;
  value: string;
};

export type DeleteIdeaCommentRequest<ID = string> = {
  commentID: ID;
};

export type CommentResponse = {
  comment: IdeaComment;
};

export enum IdeaActivityType {
  comment = 'comment',
  mergedIdea = 'mergedIdea',
  statusHistory = 'statusHistory',
}

/**
 * Discriminated union type for idea activity items.
 * Each activity type includes its relevant data inline.
 */
export type IdeaActivity =
  | {
      _id: string;
      created: string;
      type: IdeaActivityType.comment;
      comment: IdeaComment;
    }
  | {
      _id: string;
      created: string;
      type: IdeaActivityType.statusHistory;
      // TODO: Add statusHistory data when implemented
    }
  | {
      _id: string;
      created: string;
      type: IdeaActivityType.mergedIdea;
      // TODO: Add mergedIdea data when implemented
    };

export type GetIdeaActivityRequest<ID = string> = {
  ideaID: ID;
  cursor?: string | null;
  limit?: number;
  sort?: 'newest' | 'oldest';
};

export type GetIdeaActivityResponse = {
  items: IdeaActivity[];
  cursor: string | null;
  hasNextPage: boolean;
};
